import { Address } from '../types/commons';

export const EMPTY_ADDRESS_LEGACY: Partial<Address> = {
  address: undefined,
  street_name: undefined,
  street_number: undefined,
  city: undefined,
  zip_code: undefined,
  lat: undefined,
  lng: undefined,
};

export const EMPTY_ADDRESS: Partial<Address> = {
  address: '',
  city: '',
  lat: '',
  lng: '',
  street_name: '',
  street_number: '',
  zip_code: '',
};

export const ADDRESS_STREET_LETTER_OPTIONS = [
  { name: 'Bis', value: 'B' },
  { name: 'Ter', value: 'T' },
  { name: 'Quater', value: 'Q' },
  { name: 'Quinquiès', value: 'C' },
];
